// Variables
const header = document.querySelector('.header');
const nav = document.querySelector('[data-js-header-nav]');
const menu = nav.querySelector('.header__menu');

/**
 * @description Gestion du toggle du menu
 */

const toggleMenu = () =>{
    const btn = document.querySelector('.header__menu__toggle');
    btn.addEventListener('click',() => {
        nav.classList.toggle('menu-active');
        btn.classList.toggle('btn-open')
    })
}


/**
 * @description Gestion du toggle des sous menu
 */

const expandedMenu = () => {
	const btns = menu.querySelectorAll('[data-js-header-menu-expanded]');
	btns.forEach((btn) => {
		btn.addEventListener('click', () => {
			const btnParent = btn.parentNode;
			const thisSubMenu = btnParent.querySelector(
				'.header__menu__submenu'
			);
            const parentTxt = btnParent.querySelector('a').innerText;
            const thisPreviousBtn =thisSubMenu.querySelector('.header__menu__previous');
			const thisPreviousBtnTitle = thisSubMenu.querySelector('.header__menu__submenu__title')
            thisSubMenu.classList.add('submenu--open');
            thisPreviousBtnTitle.innerText = parentTxt;
		});
	});
};

/**
 * @description Gestion du bouton previous de chaque sous menu
 */
const goBackMenu = () => {
	const previousBtns = menu.querySelectorAll('.header__menu__previous');
	previousBtns.forEach((btn) => {
		btn.addEventListener('click', () => {
            const currentSubMenu = btn.parentNode.parentNode;
            currentSubMenu.classList.remove('submenu--open');
           const btnParentSubmenu = btn.closest('.submenu--open');
           const thisPreviousBtnTitle = btnParentSubmenu.querySelector('.header__menu__submenu__title')
           thisPreviousBtnTitle.innerText = parentTxt;
        });
	});
};

window.addEventListener('load', () => {
    toggleMenu();
	expandedMenu();
	goBackMenu();
});
